import { Component, OnInit } from '@angular/core';
import { ValidatorService } from '../../services';
import { QueryValidationsFilter } from '../../models';
import { MessageService, SelectItem } from 'primeng/api';
import { formatDate } from '@angular/common';
import { Subscription } from 'rxjs';
import { Utils } from '../../utils';
import * as globals from '../../globals';

@Component({
  selector: 'app-validation-report',
  templateUrl: './validation-report.component.html',
  styleUrls: ['./validation-report.component.css']
})
export class ValidationReportComponent implements OnInit {
  queryRequest: QueryValidationsFilter;
  validatorProviders: SelectItem[];
  report: any[];
  allValidationConfigs: any[];
  sub: Subscription;
  pl = globals.pl;

  constructor(
    private validatorService: ValidatorService,
    private messageService: MessageService,
    private utils: Utils
  ) { }

  ngOnInit() {
    this.queryRequest = new QueryValidationsFilter();
    this.queryRequest.dateFrom = new Date();
    this.queryRequest.dateFrom.setDate(1);
    this.queryRequest.dateFrom.setHours(0, 0, 0, 0);
    this.queryRequest.dateUntil = new Date();
    this.initForm();

  }

  initForm() {
    this.validatorService.getAllValidators().subscribe(
      v => {
        this.validatorProviders = v.map(vp => {
          return { value: vp.id, label: vp.label }
        });
        if (this.validatorProviders && this.validatorProviders.length === 1) {
          this.queryRequest.validatorProviderId = this.validatorProviders[0].value;
        }
        this.validatorService.getAllValidationConfigs(false).subscribe(vc => {
          this.allValidationConfigs = vc;
        });
      },
      error => {
        this.utils.handleError(error);
      });
  }

  generateReport() {
    this.validatorService.queryValidations(this.queryRequest).subscribe(responseData => {
      this.report = responseData;
      console.log(responseData);
    });
  }

  downloadReport(): void {
    this.validatorService.queryValidationsXls(this.queryRequest)
      .subscribe(
        responseData => {
          let file = new Blob([responseData.body], { type: responseData.headers.get('Content-Type') });
          let filename = "eWalidacje_raport_" + formatDate(Date.now(), 'yyyyMMddHHmmss', 'pl-PL') + '.xlsx';
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(file, filename);
          }
          else {
            let doc = document.createElement("a");
            let url = URL.createObjectURL(file);
            doc.href = url;
            doc.target = "_blank";
            doc.download = filename;
            doc.click();
          }
        },
        error => {
          this.messageService.add({ severity: 'error', summary: 'Błąd pobierania raportu', detail: error.error.message });
          console.log("Error downloading file: ", error);
        });
  }
}
